import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AveregeAccountLinesTrafficDto } from '../../../data/models/averege-account-lines-traffic-dto';
import { LineAveregeReadingsDto } from '../../../data/models/line-averege-readings-dto';
import { LineFullInfoDto } from '../../../data/models/line-full-info-dto';
import { LineDetailsService } from '../../../services/line-details.service';

@Component({
  selector: 'app-cc-account-traffic',
  templateUrl: './cc-account-traffic.component.html',
  styleUrls: ['./cc-account-traffic.component.scss'],
  providers: [MessageService]
})
export class CcAccountTrafficComponent {

  @Input() accountUcid: string;;

  internetChartNames: string[] = [];
  internetAvgIn: number[] = [];
  internetAvgOut: number[] = [];

  dataChartNames: string[] = [];
  dataAvgIn: number[] = [];
  dataAvgOut: number[] = [];


  showInternetChart: boolean = true ;
  showDataChart: boolean = true;
  loader:boolean = false;

  constructor(private messageService: MessageService, private lineDetailsService: LineDetailsService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    this.getAccountTrafficData(this.accountUcid);

  }
 

  getAccountTrafficData(object) {
    this.loader = true;
    //let dataObject = {
    //  /*      searchKeyword: object.basicInfo.ucId*/
    //  searchKeyword: object
    //};
    this.lineDetailsService.getAccountTrafficData().subscribe(
      (response: any) => {
        if (response != null) {
          this.preparePieChart(response);
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Line Basic Details', detail: 'Saving failed:returned null' });
        }
        this.loader = false;
      },
      (error) => {
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Line Basic Details', detail: 'Saving failed: returned error' });

      }
    );
  }

  calcLineSpeed(numberInput) {
    let gZeroes = 1000000;
    let mZeroes = 1000;
    let fractionZeroesNumber = 100;

    if (numberInput >= gZeroes) {
      return Math.round((numberInput / gZeroes) * fractionZeroesNumber) / fractionZeroesNumber + " Gbps";
    }
    else if (numberInput >= mZeroes) {
      return Math.round((numberInput / mZeroes) * fractionZeroesNumber) / fractionZeroesNumber + " Mbps";
    }
    else return Math.round(numberInput * fractionZeroesNumber) / fractionZeroesNumber + " kbps";
  }

  drawInternetPieChart() {
    let values = this.internetAvgIn;
    
    var internetOptions = {
      series: this.internetAvgIn,
      chart: {
        width: 380,
        type: 'pie',
      },
      title: {
        text: 'Top 5 Internet Speeds (kbps)'
      },
      legend: {
        show: true,
        formatter: function (names, opts) {
          return [names.slice(0, 20)]
        },
       // fontSize: '12px',
        width: 195

      },
      dataLabels: {
        enabled: true,
        formatter: function (value, val) {
          let numberInput = values[val.seriesIndex];
          let gZeroes = 1000000;
          let mZeroes = 1000;
          let fractionZeroesNumber = 100;

          if (numberInput >= gZeroes) {
            return Math.round((numberInput / gZeroes) * fractionZeroesNumber) / fractionZeroesNumber + " Gbps";
          }
          else if (numberInput >= mZeroes) {
            return Math.round((numberInput / mZeroes) * fractionZeroesNumber) / fractionZeroesNumber + " Mbps";
          }
          else return Math.round(numberInput * fractionZeroesNumber) / fractionZeroesNumber + " kbps";
          
        },

      },
      labels: this.internetChartNames,
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
        }
      }],
      noData: {
        text: 'No Data Found',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
      }
    };

    var internatChart = new ApexCharts(document.querySelector("#internetchart"), internetOptions);
    internatChart.render();
    this.loader = false;
  }

  drawDataPieChart() {
    let values = this.dataAvgIn;

    var dataOptions = {
      series: this.dataAvgIn,
      chart: {
        width: 380,
        type: 'pie',
      },
      title: {
        text: 'Top 5 Data Speeds (kbps)'
      },
      legend: {
        show: true,
        formatter: function (names, opts) {
          return [names.slice(0, 20)]
        },
        //fontSize: '12px',

        width: 195
      },
      dataLabels: {
        enabled: true,
        formatter: function (value, val) {
          let numberInput = values[val.seriesIndex];
          let gZeroes = 1000000;
          let mZeroes = 1000;
          let fractionZeroesNumber = 100;

          if (numberInput >= gZeroes) {
            return Math.round((numberInput / gZeroes) * fractionZeroesNumber) / fractionZeroesNumber + " Gbps";
          }
          else if (numberInput >= mZeroes) {
            return Math.round((numberInput / mZeroes) * fractionZeroesNumber) / fractionZeroesNumber + " Mbps";
          }
          else return Math.round(numberInput * fractionZeroesNumber) / fractionZeroesNumber + " kbps";

        },
        
      },
      labels: this.dataChartNames,       
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
        }
      }],
      noData: {
        text: 'No Data Found',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
      }
    };

    var dataChart = new ApexCharts(document.querySelector("#datachart"), dataOptions);
    dataChart.render();
    this.loader = false;
  }


  preparePieChart(data: any[]) {
    let dataItems = data.filter(x => x.serviceType == 2);
    let internetItems = data.filter(x => x.serviceType == 1);
    if (dataItems) {
      this.dataChartNames  = dataItems.map((x) => { return x.name });
      this.dataAvgIn = dataItems.map((x) => { return x.lineSpeed });
      this.drawDataPieChart ();
    }
    if (internetItems) {
      this.internetChartNames = internetItems.map((x) => { return x.name });
      this.internetAvgIn = internetItems.map((x) => { return x.lineSpeed });
      this.drawInternetPieChart();
    }
    
  }

}
